import React, { Component } from 'react';
import ServiceListItem from '../../../Domain/ServiceListItem';
import ShowNameComponent from '../../../Elements/ShowNameComponent';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import selectHelper from '../../../Helpers/selectHelper';
import OpportunityService from '../../../Services/opportunityService';
import ServiceItemService from '../../../Services/ServiceItemService';
import inPersonPages from './EditPageDescriptions/InPersonPages';
import phonePages from './EditPageDescriptions/PhonePages';
import onlineWebPages from './EditPageDescriptions/OnlineWebPages';
import interceptsPages from './EditPageDescriptions/InterceptsPages';
import auditsPages from './EditPageDescriptions/AuditsPages';
import customerSatisfactionPages from './EditPageDescriptions/CustomerSatisfactionPages';
import employeeSurveyPages from './EditPageDescriptions/EmployeeSurveyPages';
import otherPages from './EditPageDescriptions/OtherPages';
import onlineReputationPages from './EditPageDescriptions/OnlineReputationPages';
import businessIntelligencePages from './EditPageDescriptions/BusinessIntelligencePages';
import bareIfyPages from './EditPageDescriptions/BareIfyPages';
import inventoryAuditsPages from './EditPageDescriptions/InventoryAuditsPages';
import { reportingArray } from './EditPageDescriptions/SharedConstants';
import ServiceTypeEnum from '../../../Enums/ServiceTypeEnum';

class EditServiceDescription extends Component {
  static titleForCreate = (item) =>
    item.OpportunityName ? (
      `Add New Service for Opportunity #${item.OpportunityId} (${item.OpportunityName})`
    ) : (
      <span>
        Add New Service for Opportunity {item.OpportunityId} (
        <ShowNameComponent
          serviceFunction={OpportunityService.GetOpportunityNameById}
          id={item.OpportunityId}
        />
        )
      </span>
    );
  static titleForEdit = (item) => `Edit Service #${item.ServiceId}${item.Name ? ` (${item.Name})` : ''}`;
  static entityName = 'Service';
  static idField = 'ServiceId';
  static itemType = ServiceListItem;
  static serviceFunction = (edited) => ServiceItemService.EditService(edited);

  static getCommissionYearOptions() {
    //If changes are made here, EditCommissionRateWindowDescription.forRequiredYearField should be updated accordingly
    return [
      { value: null, label: 'Not Commissionable' },
      { value: 1, label: 'Year 1' },
      { value: 2, label: 'Year 2' },
    ];
  }

  static validateDescription(e, editedItem) {
    if (e && e.length <= 150) {
      return 'Description is too short.';
    }
    return ValidityHelper.forRequiredTextField(e, editedItem);
  }

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Name',
          label: 'Name',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'TypeCode',
          label: 'Type',
          className: 'col-12',
          type: InputTypesEnum.ServiceType,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'ServiceDesc',
          label: 'Description of Service/Scenario',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          tooltipText: 'Min 150 characters',
          validityChecker: EditServiceDescription.validateDescription,
        },
        {
          fieldName: 'FieldworkCycleCode',
          label: 'Fieldwork Cycle',
          className: 'col-12',
          type: InputTypesEnum.CommonCycle,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'NumCyclesPerYr',
          label: 'No. Cycles Per Year',
          className: 'col-12',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Reporting',
          label: 'Reporting',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: selectHelper.generateSelectValues(reportingArray.map((r) => r.label)),
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'CopyCountryPricings',
          label: 'Copy Country Pricings',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
          hide: (item) => item.CopyServicePricings !== 'true',
        },
        {
          fieldName: 'IncludeNumOfEvalsPerCycle',
          label: 'Include # Evals Per Cycle',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
          hide: (item) => item.CopyCountryPricings !== true,
        },
        {
          fieldName: 'CommissionYear',
          label: 'Commission Year',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: EditServiceDescription.getCommissionYearOptions(),
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CommissionExternalSalesPartnerId',
          label: 'Commission External Sales Partner',
          className: 'col-12',
          type: InputTypesEnum.ActiveExternalSalesPartnerSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'OverrideCommissionRate',
          label: 'Commission Override Rate',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: EditServiceDescription.validityCheckerforCommissionOverrideRate,
          roleKey: 'commission_override',
        },
        {
          fieldName: 'MaxDeliveryAfterShop',
          label: 'Time to Deliver Evaluation to Client',
          className: 'col-12',
          type: InputTypesEnum.MaxDeliveryAfterShop,
          hide: (item) => item.TypeCode != ServiceTypeEnum.BusinessIntelligence,
        },
      ],
    },
    ...inPersonPages,
    ...phonePages,
    ...onlineWebPages,
    ...interceptsPages,
    ...auditsPages,
    ...customerSatisfactionPages,
    ...employeeSurveyPages,
    ...otherPages,
    ...onlineReputationPages,
    ...businessIntelligencePages,
    ...bareIfyPages,
    ...inventoryAuditsPages,
  ];
}

export default EditServiceDescription;
